<template>
    <div ref="widget">
    </div>
</template>

<script type="text/babel">
export default {
    name: 'kendo-dialog',

    props: {
        content: String,
        actions: {
            type: Array,
            required: true
        },
        width: {
            type: Number,
            default: 400
        },
        visible: {
            type: Boolean,
            default: false
        }
    },

    data () {
        const config = {
            width: `${this.width}px`,
            closable: false,
            modal: false,
            content: this.content,
            actions: this.actions,
            visible: this.visible,
            close: this.onClose
        };

        return {
            title: this.title,
            config,
            widget: undefined
        };
    },

    mounted () {
        this.widget = new kendo.ui.Dialog(this.$refs.widget, this.config);
    },

    destroyed () {
        this.widget.destroy();
    },

    methods: {
        onClose () {
            this.$emit('close');
            this.widget.destroy();
        },

        open () {
            this.widget.open();
        },

        close () {
            this.widget.close();
        }
    },

    watch: {}
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/kendo-dialog/kendo-dialog.component.vue